import React, { useEffect, useState } from 'react';
import { inventoryApi, productsApi } from '../services/api';

export default function StockAdjustmentPage() {
    const [products, setProducts] = useState([]);
    const [movements, setMovements] = useState([]);
    const [saving, setSaving] = useState(false);
    const [form, setForm] = useState({
        product_id: '',
        quantity: '',
        adjustment_type: 'add',
        reason: '',
    });

    const load = async () => {
        const [productsRes, movementsRes] = await Promise.all([
            productsApi.list({ limit: 500 }),
            inventoryApi.movements({ limit: 20 }),
        ]);
        const productRows = productsRes?.data?.data || productsRes?.data || [];
        const movementRows = (movementsRes?.data?.data || []).filter((item) => item.movement_type === 'adjustment');
        setProducts(productRows);
        setMovements(movementRows);
    };

    useEffect(() => {
        load();
    }, []);

    const submit = async (event) => {
        event.preventDefault();
        if (!form.product_id || Number(form.quantity) <= 0) {
            window.alert('Select product and enter a positive quantity.');
            return;
        }

        setSaving(true);
        const response = await inventoryApi.adjustStock({
            product_id: Number(form.product_id),
            quantity: Number(form.quantity),
            adjustment_type: form.adjustment_type,
            reason: form.reason,
        });
        setSaving(false);

        if (!response.success) {
            window.alert(response.error || 'Failed to adjust stock');
            return;
        }

        setForm({ product_id: '', quantity: '', adjustment_type: 'add', reason: '' });
        load();
    };

    return (
        <div className="products-page">
            <div className="page-header products-header">
                <div>
                    <h2>Stock Adjustment</h2>
                    <p>Dashboard <span className="crumb-sep">›</span> Stock Adjustment</p>
                </div>
            </div>

            <section className="products-shell stock-shell">
                <div className="panel stock-panel">
                    <h3>Adjust Product Stock</h3>
                    <form className="stock-form-grid" onSubmit={submit}>
                        <label>
                            <span>Product</span>
                            <select value={form.product_id} onChange={(e) => setForm((prev) => ({ ...prev, product_id: e.target.value }))} required>
                                <option value="">Select product</option>
                                {products.map((item) => (
                                    <option key={item.id} value={item.id}>{item.name} ({item.sku || 'no-sku'})</option>
                                ))}
                            </select>
                        </label>
                        <label>
                            <span>Adjustment Type</span>
                            <select value={form.adjustment_type} onChange={(e) => setForm((prev) => ({ ...prev, adjustment_type: e.target.value }))}>
                                <option value="add">Increase</option>
                                <option value="subtract">Decrease</option>
                            </select>
                        </label>
                        <label>
                            <span>Quantity</span>
                            <input type="number" min="1" step="1" value={form.quantity} onChange={(e) => setForm((prev) => ({ ...prev, quantity: e.target.value }))} required />
                        </label>
                        <label>
                            <span>Reason</span>
                            <input value={form.reason} onChange={(e) => setForm((prev) => ({ ...prev, reason: e.target.value }))} placeholder="Damaged goods, recount, restock..." />
                        </label>
                        <div className="stock-form-actions">
                            <button className="btn" type="submit" disabled={saving}>{saving ? 'Saving...' : 'Apply Adjustment'}</button>
                        </div>
                    </form>
                </div>

                <div className="panel stock-panel">
                    <h3>Recent Adjustments</h3>
                    <div className="products-table-wrap">
                        <table className="products-table admin-table">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Product ID</th>
                                    <th>Quantity</th>
                                    <th>Reason</th>
                                </tr>
                            </thead>
                            <tbody>
                                {movements.length === 0 ? (
                                    <tr><td colSpan={4} className="dash-empty-row">No stock adjustments yet</td></tr>
                                ) : movements.map((item) => (
                                    <tr key={item.id}>
                                        <td>{new Date(item.created_at).toLocaleString('en-NG')}</td>
                                        <td>{item.product_id}</td>
                                        <td>{item.quantity}</td>
                                        <td>{item.notes || '-'}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    );
}
